module.exports = [
	{
		"quote": "One day I promised God that if he would give me my voice back I would never smoke again. I got three octaves back after quitting.",
		"citation": "John 3:16",
		"attribution": "mariah"
	},
	{
		"quote": "If critics have problems with my personal life, it's their problem. Anybody with half a brain would realize that it's the charts that count.",
		"citation": "Rolling Stone",
		"attribution": "mariah"
	},
	{
		"quote": "I've seen the real extreme diva behaviour and I don't think that's who I am.",
		"citation": "John 3:16",
		"attribution": "mariah"
	},
	{
		"quote": "In this world, I call the shots and I think I know best.",
		"citation": "Rolling Stone",
		"attribution": "mariah"
	},
	{
		"quote": "A lot of people are singing about how screwed up the world is, and I don't think that everybody wants to hear about that all the time.",
		"citation": "Rolling Stone",
		"attribution": "mariah"
	},
	{
		"quote": "My mother is Irish, my father is black and Venezuelan, and me - I'm tan, I guess.",
		"citation": "John 3:16",
		"attribution": "mariah"
	},
	{
		"quote": "I do not think I reinvent myself. Wearing my hair differently or changing my style of dress is playing dress-up. I don't take it too seriously.",
		"citation": "Rolling Stone",
		"attribution": "mariah"
	},
	{
		"quote": "Heartbreaker you’ve got the best of me. But I just keep on comin’ back incessantly.",
		"citation": "John 3:16",
		"attribution": "mariah"
	},
	{
		"quote": "I always felt like the rug could be pulled out from under me at anytime. And coming from a racially mixed background, I always felt like I didn’t really fit in anywhere.",
		"citation": "Rolling Stone",
		"attribution": "mariah"
	},
	{
		"quote": "I don’t mind being compared to Whitney, there are people miles worse to be compared to.",
		"citation": "Rolling Stone",
		"attribution": "mariah"
	},
	{
		"quote": "Whoever eats my flesh and drinks my blood has eternal life.",
		"citation": "John 3:16",
		"attribution": "messiah"
	},
	{
		"quote": "Be as wise as serpents and harmless as doves.",
		"citation": "Rolling Stone",
		"attribution": "messiah"
	},
	{
		"quote": "He sent me to heal the brokenhearted.",
		"citation": "John 3:16",
		"attribution": "messiah"
	},
	{
		"quote": "All authority in Heaven and earth has been handed over to me.",
		"citation": "Rolling Stone",
		"attribution": "messiah"
	},
	{
		"quote": "I am the way, the truth, and the life. No one comes to the Father except through me.",
		"citation": "Rolling Stone",
		"attribution": "messiah"
	},
	{
		"quote": "And know that I am with you always; yes, to the end of time.",
		"citation": "John 3:16",
		"attribution": "messiah"
	},
	{
		"quote": "I am Alpha and Omega, the beginning and the end, the first and the last.",
		"citation": "Rolling Stone",
		"attribution": "messiah"
	},
	{
		"quote": "If a blind person is leading a blind person, both will end up in a ditch.",
		"citation": "John 3:16",
		"attribution": "messiah"
	},
	{
		"quote": "I am gentle and humble in heart.",
		"citation": "Rolling Stone",
		"attribution": "messiah"
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/quotes.json
 ** module id = 429
 ** module chunks = 0
 **/